import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
// import { Http } from '@angular/http';
// import "rxjs/add/operator/map";

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
// import { TemplesListPage } from '../temples-list/temples-list';
// import { MemberListPage } from '../memberList/memberList';
// import { TempleDetailPage } from '../templeDetail/templeDetail';
// import { MemberDashboardPage } from '../memberDashboard/memberDashboard';
// import { MemberDetailPage } from '../memberDetail/memberDetail';
// import { AddMemberPage } from '../addMember/addMember';

@Component({
  selector: 'page-campaignDashboard',
  templateUrl: 'campaignDashboard.html',
  // styleUrls: [ 'campaignDashboard.scss', '../../theme/variables.scss' ]
})
export class CampaignDashboardPage {
  public temple: any;
  public members = [];
  templeDashboard: string = "profile";


  constructor(public navCtrl: NavController, public navParams: NavParams, public myApp: ImcpaAppProvider) {
    this.temple = this.navParams.get("temple");
    this.members = this.myApp.getMembers();

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TempleDetailsPage');
  }

  // updateTemple(temple){
  //   this.govindaProvider.key = "update";
  //   console.log("http://localhost/TempleRoutes.php?temple_name='" + temple.Temple_Name + "'&temple_id=" + temple.ID + "&temple_president='" + temple.Temple_President + "'&temple_president_phone='" + temple.Temple_President_Phone + "'&contact_name='" + temple.Contact_Name + "'&address='" + temple.Address + "'&email='" + temple.Email + "'&phone='" + temple.Phone + "'&currency_code='" + temple.Currency_Code + "'&box_price=" + temple.Box_Price + "&target_units=" + temple.Target_Units + "&key=" + this.govindaProvider.key);
  //   this.http.get("http://localhost/TempleRoutes.php?temple_name='" + temple.Temple_Name + "'&temple_id=" + temple.ID + "&temple_president='" + temple.Temple_President + "'&temple_president_phone='" + temple.Temple_President_Phone + "'&contact_name='" + temple.Contact_Name + "'&address='" + temple.Address + "'&email='" + temple.Email + "'&phone='" + temple.Phone + "'&currency_code='" + temple.Currency_Code + "'&box_price=" + temple.Box_Price + "&target_units=" + temple.Target_Units + "&key=" + this.govindaProvider.key)
  //   .map(res => res)
  //   .subscribe(res => {
  //      alert("Saved:"+ res)
  //      this.navCtrl.push(TemplesListPage)
  //    }, (err) => {
  //      alert("Failed to Load Json data" + err)
  //    });
  // }; 

  goToTempleDetailPage(temple){
    // this.navCtrl.push(TempleDetailPage, {
    //   temple: this.temple
    // });
  }

  goToMemberListPage(temple){
    // this.navCtrl.push(MemberListPage, {
    //   temple: this.temple
    // });
  }

  goToMemberDashboardPage(member){
    // this.navCtrl.push(MemberDashboardPage, {
    //   member: member, temple: this.temple
    // })
  }

  goToMemberDetailPage(member){
    // this.navCtrl.push(MemberDetailPage, {
    //   member: member, temple: this.temple
    // })
  }

  goToAddMemberPage(){
    // this.navCtrl.push(AddMemberPage, {
    //   temple: this.temple
    // });
  }

}



// WEBPACK FOOTER //
// ./src/pages/campaigns/campaignDashboard/campaignDashboard.ts